// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

import VueI18n from "vue-i18n";
import zh from "./components/common/lang/zh";
import en from "./components/common/lang/en";
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: "zh", // 语言标识
  // this.$i18n.locale // 通过切换locale的值来实现语言切换
  legacy: false,
  messages: {
    zh: { ...zh }, // 中文语言包
    en: { ...en } // 英文语言包
  }
});

import "./assets/css/common.css";
import "./assets/css/lado.css";

import myHeader from "./components/myHeader/index";
Vue.component("myHeader", myHeader);
import myFooter from "./components/myFooter/index";
Vue.component("myFooter", myFooter);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  i18n,
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js